<template>
  <div
    id="cartBox"
    class="cart-list-wrap"
    :class="{ isLogin: isLogin }"
    :style="cardSubmitStyle"
  >
    <div class="cart-header flex-between" id="cartHeader">
      <p class="cart-title">{{ cartTitle }}</p>
      <Icon
        class="cart-detail-down j-click-close-cart"
        name="down"
        @click="close"
      ></Icon>
    </div>

    <div class="product-wrap">
      <div class="product-box" id="cartProductList">
        <div
          class="product-item"
          v-for="(item, index) in cartList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID"
        >
          <div class="detail-wrap">
            <div class="left">
              <div class="left-wrap">
                <gift-icon
                  class="product-icon"
                  background=""
                  :gifts="getGiftIcons(item)"
                ></gift-icon>
              </div>
            </div>
            <div class="right">
              <div class="tag-wrap">
                <span class="product-tag" v-if="extraTip(item)">
                  {{ extraTip(item) }}
                </span>
                <span class="product-tag" v-if="+item.COUPON">{{
                  letter.couponCanUseQuan
                }}</span>
              </div>

              <div class="top-bar flex-between">
                <div>
                  <p class="product-name name">
                    {{ getProductName(item) }}
                  </p>
                  <p
                    class="product-price"
                    v-if="
                      item.amountLevel &&
                      item.amountLevel.TRANS_AMOUNT &&
                      item.amountLevel.SHOW_CURRENCY
                    "
                  >
                    {{ item.amountLevel.TRANS_AMOUNT }}
                    {{ item.amountLevel.SHOW_CURRENCY }}
                  </p>
                  <p class="product-desc name">
                    {{ getProductDetail(item) }}
                  </p>
                </div>
              </div>

              <div class="cart-bar">
                <div class="quantity">
                  <div
                    class="quantity-item action flex-center j-click-sub-to-cart-cart-list"
                    @click="doSubProduct(item, index)"
                  >
                    <Icon class="action-ico" name="minus"></Icon>
                  </div>
                  <span class="quantity-item total">{{ item.quantity }}</span>
                  <span
                    class="quantity-item action flex-center j-click-add-to-cart-cart-list"
                    @click="addToCart(item)"
                  >
                    <Icon class="action-ico" name="plus"></Icon>
                  </span>
                </div>
              </div>
            </div>
            <Icon
              class="remove-ico"
              name="close"
              @click="doRemoveProduct(item, index)"
            ></Icon>
          </div>
        </div>
      </div>
    </div>

    <div class="product-summary" id="cartSummary">
      <div class="summary-bar flex-between">
        <p>{{ letter.v3ItemPrice }}:</p>
        <p class="bold">{{ cartTotalPrice }} {{ currency }}</p>
      </div>
      <div v-if="isShowTax" class="summary-bar flex-between">
        <p>{{ letter.v3Tax }}：</p>
        <p class="bold">{{ curTax }} {{ currency }}</p>
      </div>
      <div class="submit-bar flex-between">
        <p class="total-label">{{ letter.v3Total }}</p>
        <p class="total-price">{{ realPrice }} {{ currency }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { b64EncodeUnicode } from '@utiles/officialStore';
import { mapState, mapGetters } from 'vuex';
import selectContainer from '@mixins/officialTopupNew/selectContainer';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import product from '@mixins/officialTopupNew/product';
import productName from '@mixins/product';
import extra from '@mixins/officialTopupNew/extra';
import globalConfig from '@utiles/globalConfig';

const setCartListHeight = globalConfig.throttle(() => {
  const total = document.getElementById('cartBox');
  const header = document.getElementById('cartHeader');
  const content = document.getElementById('cartProductList');
  const summary = document.getElementById('cartSummary');
  if (!total || !header || !content || !summary) return;
  const contentHeight =
    total.offsetHeight - header.offsetHeight - summary.offsetHeight + 1;
  content.style.height = `${contentHeight}px`;
}, 300);

export default {
  mixins: [selectContainer, cartAddAndDetail, product, productName, extra],
  props: ['cardSubmitStyle'],
  data() {
    return {
      currency: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      isLogin: state => state.login.isLogin
    }),
    ...mapGetters([
      'cartTotalPrice',
      'cartTotalExtraCoin',
      'cartTotalQuantity',
      'cartDiscountTransMount',
      'cartProductType',
      'getPointPayChannelName',
      'extraCoinName'
    ]),
    cartTitle() {
      return this.letter?.v3SelectedItemsN.replace(
        '${n}',
        this.cartTotalQuantity
      );
    }
  },
  watch: {
    paytype: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal?.show_currency) {
          this.currency = newVal?.show_currency;
        }
      }
    }
  },
  methods: {
    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {}
        };
      });
    },
    sendCheckCartData() {
      window.webstorev35DataLayer.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
      window.webstorev35DataLayerBatch?.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
    },
    submitCart() {
      this.$emit('submitCart');
    }
  },
  mounted() {
    setCartListHeight();
    window.addEventListener('resize', setCartListHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', setCartListHeight);
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/_dimen.scss';

.cart-list-wrap {
  overflow: hidden;
  box-sizing: border-box;
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  right: 0;
  bottom: 370px;
  width: 670px;
  max-height: 70vh;
  margin: auto;
  border-radius: 10px;
  background-color: $backgroundColor;
  color: #333333;

  &.isLogin {
    bottom: 120px;
  }

  .cart-header {
    @include g-popup-title();
    position: relative;
    flex-shrink: 0;
    padding: 40px;

    .cart-title {
      font-size: 28px;
      font-weight: bold;
    }

    .cart-detail-down {
      flex-shrink: 0;
      width: 38px;
      height: 38px;
      margin-left: 10px;
      cursor: pointer;
    }
  }

  .product-wrap {
    padding: 0 30px;
    .product-box {
      max-height: 40vh;
      height: 757px;
      overflow-y: scroll;
      padding: 0 10px;
      scrollbar-width: 1px !important;
      .product-item {
        box-sizing: border-box;
        margin-bottom: 20px;
        border-bottom: 1px solid #e7e7e7;

        &:last-child {
          border-bottom: none;
        }

        .tag-wrap {
          margin-bottom: 10px;

          .product-tag {
            display: inline-block;
            font-size: 20px;
            padding: 8px 20px 8px 10px;
            background: linear-gradient(
              348deg,
              $buttonGradientColor1,
              $buttonGradientColor2
            );
            color: #ffffff;
            border-radius: 4px 4px 36px 4px;
          }
          .product-tag + .product-tag {
            margin-left: 10px;
          }
        }
        .detail-wrap {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          padding: 20px 0;
          .left {
            &-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 94px;
              height: 94px;
              background-color: #f3f1ef;
              border-radius: 20px;
              .product-icon {
                width: 100%;
                height: auto;
                zoom: 0.4;
              }
            }
          }
          .right {
            margin-left: 30px;
            flex: 1;
            word-break: break-word;
            .top-bar {
              line-height: 1.5;
              .product-name {
                margin-bottom: 4px;
                font-size: 22px;
                font-weight: bold;
                line-height: 1.2;
              }
              .product-price {
                margin-bottom: 4px;
                font-size: 24px;
                color: $themeColor;
              }
              .product-desc {
                padding-left: 10px;
                font-size: 20px;
                color: #999999;
              }
            }
            .cart-bar {
              margin-top: 16px;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              .quantity {
                height: 40px;
                display: flex;
                align-items: center;
                border-radius: 6px;
                border: 1px solid #d2d1d1;

                .quantity-item {
                  font-size: 20px;
                  font-weight: bold;

                  &.action {
                    width: 40px;
                    height: 40px;
                    cursor: pointer;

                    .action-ico {
                      width: 22px;
                      height: 22px;
                    }
                  }
                  &.total {
                    display: inline-block;
                    min-width: 40px;
                    height: 100%;
                    line-height: 40px;
                    text-align: center;
                    border-left: 1px solid #d2d1d1;
                    border-right: 1px solid #d2d1d1;
                  }
                }
              }
            }

            .quantity {
              .quantity-item {
                &.action {
                  width: 50px;
                }
              }
            }
          }

          .remove-ico {
            flex-shrink: 0;
            width: 45px;
            height: 38px;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .product-summary {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: 40px;
    background-color: #ffffff;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -10px 10px rgba(0, 0, 0, 0.05);

    .summary-bar {
      line-height: 1.2;
      font-size: 26px;
      margin-bottom: 20px;
    }
    .submit-bar {
      line-height: 1.2;
      font-size: 26px;
      margin-bottom: 10px;

      .total-label {
        font-size: 30px;
        font-weight: bold;
      }

      .total-price {
        margin-top: 10px;
        font-size: 30px;
        font-weight: bold;
        line-height: 1.2;
        color: $themeColor;
      }
      .submit-btn {
        font-size: 26px;
        min-width: 256px;
        background-color: $themeColor;
        padding: 10px 20px;
        border-radius: 9px;
        color: #ffffff;
      }
    }
  }
}

#ssr-page.landscape {
  .cart-list-wrap {
    width: 614px;
    bottom: 60px;
    max-height: calc(100% - 260px);
    transform: translate3d(165px, 0, 0);

    .cart-header {
      .cart-title {
        font-size: 24px;
      }
      .cart-detail-down {
        cursor: pointer;
        width: 28px;
        height: 28px;
      }
    }
  }
  .product-wrap {
    height: 467px;
    .product-box {
      max-height: unset !important;
      height: 360px;
      .product-item {
        padding: 24px;
        margin-bottom: 10px;
        .tag-wrap {
          .product-tag {
            font-size: 18px;
          }
        }
        .detail-wrap {
          .left {
            transform: scale(0.5);
            .product-icon {
              width: 80px;
              height: auto;
              zoom: 1 !important;
            }
          }
          .right {
            margin-left: 24px;
            .top-bar {
              .product-name {
                font-size: 18px;
              }
              .product-desc {
                font-size: 16px;
              }
              .remove-ico {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }
    }
  }
  .product-summary {
    .summary-bar {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .submit-bar {
      font-size: 20px;
      margin: 20px 0;
      .total-price {
        margin-top: 0;
        font-size: 26px;
      }
      .submit-btn {
        font-size: 26px;
        min-width: 216px;
        height: 49px;
      }
    }
  }
  .submit-btn {
    display: none;
  }
}
</style>
